import { SxProps, Theme, Typography, TypographyProps } from '@mui/material';
import { TRIGGER_FONT_SIZE, TRIGGER_LINE_HEIGHT } from 'src/components/SelectTrigger';

// A value rendered as text sits in the same row as one rendered by a trigger, so it
// borrows the trigger's voice instead of approximating it.
const BASE_SX: SxProps<Theme> = {
  fontSize: TRIGGER_FONT_SIZE,
  lineHeight: TRIGGER_LINE_HEIGHT,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  overflowWrap: 'anywhere',
};

export const AttributeText = ({ sx, ...props }: TypographyProps) => (
  <Typography variant="body2" sx={{ ...BASE_SX, ...sx }} {...props} />
);
